module.exports = __webpack_public_path__ + "static/media/g-4-b.514fb750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-4-b.jpg
// module id = 1137
// module chunks = 33